import React from 'react';
import './Icon.scss';

// Declaración de tipo para require.context() de webpack
interface RequireContext {
  keys(): string[];
  (id: string): any;
  <T>(id: string): T;
  resolve(id: string): string;
  id: string;
}

interface NodeRequire {
  context(
    directory: string,
    useSubdirectories?: boolean,
    regExp?: RegExp,
    mode?: string
  ): RequireContext;
}

interface IconProps {
  svgFilePath: string;
  isAlt?: boolean;
  isBrokerMode?: boolean;
}

// Cargar todos los SVG automáticamente usando require.context()
// Esto crea un mapa de todos los iconos sin necesidad de importarlos manualmente
// Ruta relativa: desde Icon.tsx (shared/components/ui/atoms/Icon/) hasta assets/icons/ en Onboarding/
const iconContext = (require as any).context(
  '../../../../../assets/icons',
  false,
  /\.svg$/
);

// Crear un mapa de iconos: nombre del archivo -> módulo importado
const iconMap = iconContext.keys().reduce((acc: Record<string, any>, key: string) => {
  const iconName = key.replace('./', '').replace('.svg', '');
  const iconModule = iconContext(key);
  // El módulo puede tener un default o ser el módulo directamente
  acc[iconName] = iconModule.default || iconModule;
  return acc;
}, {});

export const Icon: React.FC<IconProps> = (props) => {
  let { svgFilePath, isAlt, isBrokerMode } = props;

  // Extraer el nombre del archivo de la ruta
  let fileName = '';
  
  // Normalizar diferentes formatos de rutas
  if (svgFilePath.includes('./assets/')) {
    fileName = svgFilePath.replace('./assets/icons/', '').replace('.svg', '');
  } else if (svgFilePath.includes('/assets/')) {
    fileName = svgFilePath.split('/assets/icons/')[1]?.replace('.svg', '') || '';
  } else if (svgFilePath.includes('assets/icons/')) {
    fileName = svgFilePath.split('assets/icons/')[1]?.replace('.svg', '') || '';
  } else if (svgFilePath.includes('/Onboarding/assets/')) {
    fileName = svgFilePath.split('/Onboarding/assets/icons/')[1]?.replace('.svg', '') || '';
  } else if (svgFilePath.includes('/scenes/Onboarding/assets/')) {
    fileName = svgFilePath.split('/scenes/Onboarding/assets/icons/')[1]?.replace('.svg', '') || '';
  } else {
    // Extraer el nombre del archivo de la ruta completa
    const match = svgFilePath.match(/([^/]+)\.svg$/);
    fileName = match ? match[1] : '';
  }

  // Determinar la variante final basada en props
  let finalFileName = fileName;
  if (isBrokerMode && isAlt && iconMap[`${fileName}-blue-alt`]) {
    finalFileName = `${fileName}-blue-alt`;
  } else if (isBrokerMode && iconMap[`${fileName}-blue`]) {
    finalFileName = `${fileName}-blue`;
  } else if (isAlt && iconMap[`${fileName}-alt`]) {
    finalFileName = `${fileName}-alt`;
  }

  // Obtener el icono del mapa (fallback al icono base si no existe la variante)
  const imageSrc = iconMap[finalFileName] || iconMap[fileName] || '';

  return (
    <img className='icon' src={imageSrc} alt="icon" />
  );
}